// Forma CRUDA del listado de links de Broxel, tal cual la reenvía el BFF en
// `GET bff/payment-links-view/broxel/raw` (passthrough de GET /gateway/api/v2/link).
// El envelope y los nombres de campo son los de Broxel (snake_case, amount como string).
import { PaymentLinkView } from './payment-link-view';

export interface BroxelRawMerchant {
  id_merchant: number;
  name_merchant: string;
}

export interface BroxelRawRecord {
  id: number;
  token: string;
  id_merchant: number;
  concept: string;
  amount: string; // Broxel lo entrega como string, p. ej. "40.00"
  expire_date?: string;
  status: number;
  status_concept: string; // etiqueta legible de Broxel, p. ej. "Pendiente"
  merchant?: BroxelRawMerchant;
  created_at?: string;
  updated_at?: string;
  // URL pública del link, autoritativa de Broxel — pendiente de que el BFF la agregue
  // aquí (ya la agrega en la creación); el front NO la arma, solo la muestra tal cual.
  url?: string;
}

export interface BroxelRawPaymentLinksResponse {
  success: boolean;
  message: string;
  data: {
    currentPage: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
    records: BroxelRawRecord[];
  };
}

/**
 * Adapta un registro CRUDO de Broxel a `PaymentLinkView` para reutilizar los
 * componentes existentes (tabla de últimos links) sin cambiarlos. La moneda no viene
 * en el passthrough, así que se asume MXN; `url` se usa tal cual la entrega el BFF, sin
 * reconstruirla del lado del front.
 */
export const mapBroxelRawToView = (record: BroxelRawRecord): PaymentLinkView => ({
  id: String(record.id),
  providerId: '',
  merchantId: String(record.id_merchant),
  status: record.status_concept ?? String(record.status),
  token: record.token,
  url: record.url,
  concept: record.concept,
  amount: Number(record.amount) || 0,
  currencyCode: 'MXN',
  isAmountFixed: true,
  isReusable: false,
  expireDate: record.expire_date,
  createdAt: record.created_at ?? '',
  updatedAt: record.updated_at ?? record.created_at ?? '',
});
